import React from "react";
import { ActionBar } from "@redriver/cinnamon";
import { Button, Popup } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { addWorkspaceDirectory } from "features/System/WorkspaceMenu/actions";
import { useHistory, Link } from "react-router-dom";
import { matchPath } from "react-router";
import { PermissionCheck } from "components/auth";
import { Actions, Targets } from "constants/permissions";
import FilterWorkspaceContent from "./FilterWorkspaceContent";
import AddDirectory from "./AddDirectory";
import UploadFileModal from "./UploadFileModal";
import { getDirectorySlug } from "modules/helpers";
import { SiteRoutes } from "constants/routes";
import NotificationLevelPicker from "./NotificationLevelPicker";

const WorkspaceContentActionBar = ({
  path,
  directoryId,
  onChangeFilters,
  onRefresh,
  filters,
  canEdit,
  skipRoot,
  rootSource = "",
  siteId,
  siteRootDirectoryId,
  notificationFrequency,
  notificationActivities,
  inheritedNotificationFrequency,
  inheritedNotificationActivities,
  canReorder,
  reordering,
  setReordering,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <ActionBar>
      <ActionBar.Item>
        <FilterWorkspaceContent
          value={filters}
          onChange={onChangeFilters}
          disabled={reordering}
        />
      </ActionBar.Item>
      <ActionBar.Item fluid align="right">
        {canEdit && (
          <PermissionCheck action={Actions.Create} target={Targets.File}>
            <UploadFileModal
              compact
              content="Upload File"
              directoryId={directoryId}
              onClose={(added) => (added ? onRefresh() : null)}
              disabled={reordering}
            />
            <AddDirectory
              compact
              content="Add Folder"
              onAdded={(folder) => {
                const targetPaths = path.filter((_, i) =>
                  skipRoot ? i != 0 : true
                );
                const target =
                  rootSource +
                  (targetPaths.length > 0 ? "/" : "") +
                  targetPaths.join("/") +
                  "/" +
                  getDirectorySlug(folder.reference, folder.name);
                history.push(target);
                dispatch(
                  addWorkspaceDirectory(
                    directoryId,
                    folder.id,
                    folder.name,
                    folder.reference
                  )
                );
              }}
              directoryId={directoryId}
              disabled={reordering}
            />
          </PermissionCheck>
        )}
        <PermissionCheck action={Actions.Reorder} target={Targets.File}>
          {canReorder ? (
            <Button compact onClick={() => setReordering(!reordering)}>
              {reordering ? "Save Order" : "Reorder"}
            </Button>
          ) : (
            <Popup
              content="Remove all filters and sorting to reorder"
              trigger={
                <span>
                  <Button disabled compact>
                    Reorder
                  </Button>
                </span>
              }
            />
          )}
        </PermissionCheck>
        {!matchPath(history.location.pathname, SiteRoutes.Site(siteId)) && (
          <PermissionCheck action={Actions.View} target={Targets.Site}>
            <Link to={SiteRoutes.Site(siteId)}>
              <Button compact>Go to Site</Button>
            </Link>
          </PermissionCheck>
        )}
        <NotificationLevelPicker
          item={{
            id: directoryId,
            notificationFrequency,
            notificationActivities,
          }}
          inheritedFrequency={inheritedNotificationFrequency}
          inheritedActivities={inheritedNotificationActivities}
          canInherit={directoryId != siteRootDirectoryId}
          onRefresh={onRefresh}
        />
      </ActionBar.Item>
    </ActionBar>
  );
};

export default WorkspaceContentActionBar;
